<template>
  <!--
    Q9 — คะแนนเป็น null ได้แล้ว (เคสยังไม่ประเมิน / ข้าม / รอคิว)
    ⚠️ แสดง "—" ไม่ใช่ 0 — ศูนย์คือ "ได้ศูนย์คะแนน" ซึ่งเป็นข้อกล่าวหาร้ายแรง
       ต่อเจ้าหน้าที่ ส่วน "—" คือ "ยังไม่มีคะแนน" · และไม่ใส่จุดสีเพราะสีผูกกับ
       ระดับคะแนนที่ยังไม่มีอยู่จริง
  -->
  <span v-if="score == null" class="text-medium-emphasis qa-score">—</span>
  <span v-else class="d-inline-flex align-center qa-score">
    <v-icon :color="color" size="10" class="mr-1">mdi-circle</v-icon>
    <span class="font-weight-medium" :class="strong ? 'text-body-1' : 'text-body-2'">{{ score }}</span>
    <span v-if="showMax" class="text-caption text-medium-emphasis ml-1">/ 100</span>
  </span>
</template>

<script>
import { scoreColor } from '@/utils/qaScoring';
import { statusColor } from '@/utils/qaFormat';

export default {
  name: 'QaScoreCell',
  props: {
    // ⚠️ เลิก required — null/undefined เป็นค่าปกติของเคสที่ยังไม่ถูกประเมิน
    score: { type: Number, default: null },

    /**
     * Q10 — ผลตัดสินจาก server (pass|borderline|fail) ถ้ามี
     *
     * ⚠️ ส่งมาเมื่อไหร่ให้ใช้ตัวนี้เป็นสี **ห้ามเดาจากตัวเลข** — `scoreColor` ถือเกณฑ์
     *    85/80 ฮาร์ดโค้ดไว้ ซึ่งเป็นสำเนาที่สองของ pass mark ที่ตั้งได้จากหน้า Settings
     *    ถ้าธนาคารตั้ง pass mark เป็น 75 สีบนตารางจะเถียงกับ chip ผลตัดสินในแถวเดียวกัน
     */
    status: { type: String, default: null },
    showMax: { type: Boolean, default: false },
    strong: { type: Boolean, default: false },
  },
  computed: {
    color() {
      // ค่าเฉลี่ยรวม (หน้า Overview/Agents) ไม่มี verdict ต่อแถว — ตกไปใช้ heuristic ตามระดับคะแนน
      return this.status ? statusColor(this.status) : scoreColor(this.score);
    },
  },
};
</script>

<style scoped>
.qa-score {
  font-variant-numeric: tabular-nums;
}
</style>
